// src/services/api.ts
import axios from "axios";
import { LicenseType, Question } from "../types";

const API_URL = "https://groqprompt.netlify.app/api/ai";

export const fetchExamQuestions = async (
  licenseType: LicenseType,
): Promise<Question[]> => {
  const numberOfQuestions = licenseType.startsWith("A") ? 5 : 10;
  // Prompt được thiết kế để ép kiểu trả về JSON nghiêm ngặt
  const prompt = `
    Đóng vai trò là giảng viên lái xe tại Việt Nam. 
    Hãy tạo ra một đề thi thử gồm ${numberOfQuestions} câu hỏi trắc nghiệm ngẫu nhiên thuộc bộ câu hỏi thi sát hạch lái xe hạng ${licenseType} mới nhất theo quy định Bộ Giao thông Vận tải.
    
    Yêu cầu bắt buộc về định dạng Output:
    1. Chỉ trả về một mảng JSON thuần túy.
    2. Không được có markdown block (như \`\`\`json), không có lời dẫn.
    3. Cấu trúc JSON cho mỗi câu hỏi:
       - id: số nguyên
       - question: nội dung câu hỏi (string)
       - options: mảng chứa 3 hoặc 4 đáp án (array string)
       - correctAnswer: chỉ số của đáp án đúng trong mảng options (bắt đầu từ 0)
       - explanation: giải thích ngắn gọn tại sao đúng (string)
       - isParalysis: boolean (true nếu là câu điểm liệt)
  `;

  try {
    const response = await axios.post(API_URL, {
      prompt: prompt,
    });

    // Xử lý dữ liệu trả về
    let rawData = response.data.result;

    // Làm sạch chuỗi nếu AI lỡ thêm markdown
    rawData = rawData
      .replace(/```json/g, "")
      .replace(/```/g, "")
      .trim();

    const questions: Question[] = JSON.parse(rawData);
    return questions;
  } catch (error) {
    console.error("Lỗi khi lấy câu hỏi:", error);
    throw new Error("Không thể tạo đề thi lúc này. Vui lòng thử lại.");
  }
};
